import { all, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/preDeliveryNote';
import callToAPI from '../../../utils/callToAPI';
import PreRegisteredDocument from '../../../models/PreRegisteredDocument';

function* getPreRegisteredDocuments({ payload }) {
  yield callToAPI({
    apiCall: Api.listPreDeliveryNote,
    successResponseCode: 200,
    errorType: types.GET_PRE_REGISTERED_DOCUMENTS_ERROR,
    *callback(response) {
      yield put({
        type: types.GET_PRE_REGISTERED_DOCUMENTS_SUCCESS,
        payload: {
          preRegisteredDocuments: response.data.data.map(
            (preRegisteredDocuments) => {
              return new PreRegisteredDocument(preRegisteredDocuments);
            },
          ),
          total: response.data.total,
        },
      });
    },
    payload,
  });
}

function* deletePreRegisterDocuments({ payload }) {
  yield callToAPI({
    apiCall: Api.deletePreDeliveryNote,
    successResponseCode: 200,
    errorType: types.DELETE_PRE_REGISTERED_DOCUMENTS_ERROR,
    *callback() {
      yield put({
        type: types.DELETE_PRE_REGISTERED_DOCUMENTS_SUCCESS,
        payload,
      });
    },
    payload,
  });
}

/* watchers */
function* watcherGetPreRegisteredDocuments() {
  yield takeEvery(
    types.GET_PRE_REGISTERED_DOCUMENTS_REQUEST,
    getPreRegisteredDocuments,
  );
}
function* watcherDeletePreRegisteredDocuments() {
  yield takeEvery(
    types.DELETE_PRE_REGISTERED_DOCUMENTS_REQUEST,
    deletePreRegisterDocuments,
  );
}

export default function* rootSaga() {
  yield all([
    fork(watcherGetPreRegisteredDocuments),
    fork(watcherDeletePreRegisteredDocuments),
  ]);
}
